import { Noto_Sans_JP } from "next/font/google";
import { type ReactNode, useEffect } from "react";

const notoSansJp = Noto_Sans_JP({
  weight: ["400", "500", "700"],
  subsets: ["latin"],
  // FIXME: storybook 上だと variable がセットされない. @storybook/experimental-nextjs-vite の問題な気がする
  variable: "--speria-fonts-Noto-Sans-JP", // @repo/ui3/variables
});

export const FontsLoader = ({ children }: { children?: ReactNode }) => {
  useEffect(() => {
    // Body に class をセットすることで、 Toast 等 Portal を使って Body 直下に要素が追加されるコンポーネントについても期待通りフォントが適用されるようにする
    document.body.classList.add(notoSansJp.className);
    return () => {
      document.body.classList.remove(notoSansJp.className);
    };
  }, []);

  return <>{children}</>;
};
